import React, { useState, useEffect, forwardRef } from "react";
import { useForm } from "react-hook-form";
import TextField from "@mui/material/TextField";
import useFetch from "../../../../../hooks/useFetch";
import FileUploader from "../../../../shares/fileUploader/FileUplaoder";
import ModalShell from "../../../../shares/dashboard/ModalShell";

const FORM_ID = "add-answer-form";

const AddAnswer = forwardRef(({ close, get, id }, ref) => {
  const [payload, setPayload] = useState();
  const [call, setCall] = useState({
    q1_score: null,
    q2_score: null,
    q3_score: null,
    q4_score: null,
    q5_score: null,
    q6_score: null,
    q7_score: null,
    q8_score: null,
    q9_score: null,
    q10_score: null,
    q11_score: null,
    q12_score: null,
    q13_score: null,
    q14_score: null,
    q15_score: null,
    q16_score: null,
    q17_score: null,
    q18_score: null,
    q19_score: null,
    q20_score: null,
    extra_score: null,

    assignment_teacher_file: null,
  });

  const newGroup = useFetch({
    method: "PATCH",
    url: `management/assignment-scores/${id}/`,
    noHeader: false,
    trigger: false,
    data: payload,
    caller: get,
  });

  const getScore = useFetch({
    method: "GET",
    url: `management/assignment-scores/${id}/`,
    noHeader: false,
    trigger: true,
    setter: setCall,
  });

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    values: call,
  });

  const onSubmit = (e) => {
    const formData = new FormData();

    formData.append("q1_score", call.q1_score ?? 0);
    formData.append("q2_score", call.q2_score ?? 0);
    formData.append("q3_score", call.q3_score ?? 0);
    formData.append("q4_score", call.q4_score ?? 0);
    formData.append("q5_score", call.q5_score ?? 0);
    formData.append("q6_score", call.q6_score ?? 0);
    formData.append("q7_score", call.q7_score ?? 0);
    formData.append("q8_score", call.q8_score ?? 0);
    formData.append("q9_score", call.q9_score ?? 0);
    formData.append("q10_score", call.q10_score ?? 0);
    formData.append("q11_score", call.q11_score ?? 0);
    formData.append("q12_score", call.q12_score ?? 0);
    formData.append("q13_score", call.q13_score ?? 0);
    formData.append("q14_score", call.q14_score ?? 0);
    formData.append("q15_score", call.q15_score ?? 0);
    formData.append("q16_score", call.q16_score ?? 0);
    formData.append("q17_score", call.q17_score ?? 0);
    formData.append("q18_score", call.q18_score ?? 0);
    formData.append("q19_score", call.q19_score ?? 0);
    formData.append("q20_score", call.q20_score ?? 0);
    formData.append("extra_score", call.extra_score ?? 0);

    if (call.assignment_teacher_file instanceof File) {
      formData.append("assignment_teacher_file", call.assignment_teacher_file);
    }
    formData.append("assignment_marked", true);

    setPayload(formData);

    newGroup.reFetch();
  };

  useEffect(() => {
    newGroup.status === 200 && close();
  }, [newGroup.status]);

  return (
    <ModalShell
      ref={ref}
      close={close}
      title="تصحیح تکلیف"
      subtitle="نمره هر سوال و فایل تصحیح‌شده را ثبت کنید"
      width="max-w-[64rem]"
      footer={
        <div className="flex justify-start">
          <button
            form={FORM_ID}
            type="submit"
            disabled={newGroup.loading}
            className="rounded-soft bg-primary px-2xl py-sm text-base text-white transition-colors duration-150 hover:bg-primary-hover active:bg-primary-active focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-60 motion-reduce:transition-none"
          >
            {newGroup.loading ? "در حال ثبت…" : "ثبت نمرات"}
          </button>
        </div>
      }
    >
      <form
        id={FORM_ID}
        onSubmit={handleSubmit(onSubmit)}
        className="text-sm"
      >
        <div className="grid grid-cols-5 gap-x-3 max-md:grid-cols-3 max-sm:grid-cols-2">
          <div className="mb-6">
            <label htmlFor={"q1_score"} className="mb-2xs block text-sm text-ink-muted">
              سوال 1
            </label>
            <TextField
              name="q1_score"
              value={call.q1_score}
              placeholder="سوال 1"
              {...register("q1_score", {
                required: "نمره را وارد کنید",
              })}
              error={!!errors.q1_score}
              // helperText={errors.q1_score ? errors.q1_score.message : ""}
              onChange={(e) => {
                setCall({ ...call, q1_score: e.target.value });
              }}
              fullWidth
            />
          </div>
          <div className="mb-6">
            <label htmlFor={"q2_score"} className="mb-2xs block text-sm text-ink-muted">
              سوال 2
            </label>
            <TextField
              name="q2_score"
              value={call.q2_score}
              placeholder="سوال 2"
              {...register("q2_score", {
                required: "نمره را وارد کنید",
              })}
              error={!!errors.q2_score}
              // helperText={errors.q2_score ? errors.q2_score.message : ""}
              onChange={(e) => {
                setCall({ ...call, q2_score: e.target.value });
              }}
              fullWidth
            />
          </div>
          <div className="mb-6">
            <label htmlFor={"q3_score"} className="mb-2xs block text-sm text-ink-muted">
              سوال 3
            </label>
            <TextField
              name="q3_score"
              value={call.q3_score}
              placeholder="سوال 3"
              {...register("q3_score", {
                required: "نمره را وارد کنید",
              })}
              error={!!errors.q3_score}
              // helperText={errors.q3_score ? errors.q1_score.message : ""}
              onChange={(e) => {
                setCall({ ...call, q3_score: e.target.value });
              }}
              fullWidth
            />
          </div>
          <div className="mb-6">
            <label htmlFor={"q4_score"} className="mb-2xs block text-sm text-ink-muted">
              سوال 4
            </label>
            <TextField
              name="q4_score"
              value={call.q4_score}
              placeholder="سوال 4"
              {...register("q4_score", {
                required: "نمره را وارد کنید",
              })}
              error={!!errors.q4_score}
              // helperText={errors.q4_score ? errors.q1_score.message : ""}
              onChange={(e) => {
                setCall({ ...call, q4_score: e.target.value });
              }}
              fullWidth
            />
          </div>
          <div className="mb-6">
            <label htmlFor={"q5_score"} className="mb-2xs block text-sm text-ink-muted">
              سوال 5
            </label>
            <TextField
              name="q5_score"
              value={call.q5_score}
              placeholder="سوال 5"
              {...register("q5_score", {
                required: "نمره را وارد کنید",
              })}
              error={!!errors.q5_score}
              // helperText={errors.q5_score ? errors.q1_score.message : ""}
              onChange={(e) => {
                setCall({ ...call, q5_score: e.target.value });
              }}
              fullWidth
            />
          </div>
          <div className="mb-6">
            <label htmlFor={"q6_score"} className="mb-2xs block text-sm text-ink-muted">
              سوال 6
            </label>
            <TextField
              name="q6_score"
              value={call.q6_score}
              placeholder="سوال 6"
              {...register("q6_score", {
                required: "نمره را وارد کنید",
              })}
              error={!!errors.q6_score}
              // helperText={errors.q6_score ? errors.q1_score.message : ""}
              onChange={(e) => {
                setCall({ ...call, q6_score: e.target.value });
              }}
              fullWidth
            />
          </div>
          <div className="mb-6">
            <label htmlFor={"q7_score"} className="mb-2xs block text-sm text-ink-muted">
              سوال 7
            </label>
            <TextField
              name="q7_score"
              value={call.q7_score}
              placeholder="سوال 7"
              {...register("q7_score", {
                required: "نمره را وارد کنید",
              })}
              error={!!errors.q7_score}
              // helperText={errors.q7_score ? errors.q1_score.message : ""}
              onChange={(e) => {
                setCall({ ...call, q7_score: e.target.value });
              }}
              fullWidth
            />
          </div>
          <div className="mb-6">
            <label htmlFor={"q8_score"} className="mb-2xs block text-sm text-ink-muted">
              سوال 8
            </label>
            <TextField
              name="q8_score"
              value={call.q8_score}
              placeholder="سوال 8"
              {...register("q8_score", {
                required: "نمره را وارد کنید",
              })}
              error={!!errors.q8_score}
              // helperText={errors.q8_score ? errors.q1_score.message : ""}
              onChange={(e) => {
                setCall({ ...call, q8_score: e.target.value });
              }}
              fullWidth
            />
          </div>
          <div className="mb-6">
            <label htmlFor={"q9_score"} className="mb-2xs block text-sm text-ink-muted">
              سوال 9
            </label>
            <TextField
              name="q9_score"
              value={call.q9_score}
              placeholder="سوال 9"
              {...register("q9_score", {
                required: "نمره را وارد کنید",
              })}
              error={!!errors.q9_score}
              // helperText={errors.q9_score ? errors.q1_score.message : ""}
              onChange={(e) => {
                setCall({ ...call, q9_score: e.target.value });
              }}
              fullWidth
            />
          </div>
          <div className="mb-6">
            <label htmlFor={"q10_score"} className="mb-2xs block text-sm text-ink-muted">
              سوال 10
            </label>
            <TextField
              name="q10_score"
              value={call.q10_score}
              placeholder="سوال 10"
              {...register("q10_score", {
                required: "نمره را وارد کنید",
              })}
              error={!!errors.q10_score}
              // helperText={errors.q10_score ? errors.q1_score.message : ""}
              onChange={(e) => {
                setCall({ ...call, q10_score: e.target.value });
              }}
              fullWidth
            />
          </div>
          <div className="mb-6">
            <label htmlFor={"q11_score"} className="mb-2xs block text-sm text-ink-muted">
              سوال 11
            </label>
            <TextField
              name="q11_score"
              value={call.q11_score}
              placeholder="سوال 11"
              {...register("q11_score")}
              error={!!errors.q11_score}
              // helperText={errors.q11_score ? errors.q11_score.message : ""}
              onChange={(e) => {
                setCall({ ...call, q11_score: e.target.value });
              }}
              fullWidth
            />
          </div>
          <div className="mb-6">
            <label htmlFor={"q12_score"} className="mb-2xs block text-sm text-ink-muted">
              سوال 12
            </label>
            <TextField
              name="q12_score"
              value={call.q12_score}
              placeholder="سوال 12"
              {...register("q12_score")}
              error={!!errors.q12_score}
              // helperText={errors.q12_score ? errors.q12_score.message : ""}
              onChange={(e) => {
                setCall({ ...call, q12_score: e.target.value });
              }}
              fullWidth
            />
          </div>
          <div className="mb-6">
            <label htmlFor={"q13_score"} className="mb-2xs block text-sm text-ink-muted">
              سوال 13
            </label>
            <TextField
              name="q13_score"
              value={call.q13_score}
              placeholder="سوال 13"
              {...register("q13_score")}
              error={!!errors.q13_score}
              // helperText={errors.q13_score ? errors.q13_score.message : ""}
              onChange={(e) => {
                setCall({ ...call, q13_score: e.target.value });
              }}
              fullWidth
            />
          </div>
          <div className="mb-6">
            <label htmlFor={"q14_score"} className="mb-2xs block text-sm text-ink-muted">
              سوال 14
            </label>
            <TextField
              name="q14_score"
              value={call.q14_score}
              placeholder="سوال 14"
              {...register("q14_score")}
              error={!!errors.q14_score}
              // helperText={errors.q14_score ? errors.q14_score.message : ""}
              onChange={(e) => {
                setCall({ ...call, q14_score: e.target.value });
              }}
              fullWidth
            />
          </div>
          <div className="mb-6">
            <label htmlFor={"q15_score"} className="mb-2xs block text-sm text-ink-muted">
              سوال 15
            </label>
            <TextField
              name="q15_score"
              value={call.q15_score}
              placeholder="سوال 15"
              {...register("q15_score")}
              error={!!errors.q15_score}
              // helperText={errors.q15_score ? errors.q15_score.message : ""}
              onChange={(e) => {
                setCall({ ...call, q15_score: e.target.value });
              }}
              fullWidth
            />
          </div>
          <div className="mb-6">
            <label htmlFor={"q16_score"} className="mb-2xs block text-sm text-ink-muted">
              سوال 16
            </label>
            <TextField
              name="q16_score"
              value={call.q16_score}
              placeholder="سوال 16"
              {...register("q16_score")}
              error={!!errors.q16_score}
              // helperText={errors.q16_score ? errors.q16_score.message : ""}
              onChange={(e) => {
                setCall({ ...call, q16_score: e.target.value });
              }}
              fullWidth
            />
          </div>
          <div className="mb-6">
            <label htmlFor={"q17_score"} className="mb-2xs block text-sm text-ink-muted">
              سوال 17
            </label>
            <TextField
              name="q17_score"
              value={call.q17_score}
              placeholder="سوال 17"
              {...register("q17_score")}
              error={!!errors.q17_score}
              // helperText={errors.q17_score ? errors.q17_score.message : ""}
              onChange={(e) => {
                setCall({ ...call, q17_score: e.target.value });
              }}
              fullWidth
            />
          </div>
          <div className="mb-6">
            <label htmlFor={"q18_score"} className="mb-2xs block text-sm text-ink-muted">
              سوال 18
            </label>
            <TextField
              name="q18_score"
              value={call.q18_score}
              placeholder="سوال 18"
              {...register("q18_score")}
              error={!!errors.q18_score}
              // helperText={errors.q18_score ? errors.q18_score.message : ""}
              onChange={(e) => {
                setCall({ ...call, q18_score: e.target.value });
              }}
              fullWidth
            />
          </div>
          <div className="mb-6">
            <label htmlFor={"q1_score"} className="mb-2xs block text-sm text-ink-muted">
              سوال 19
            </label>
            <TextField
              name="q19_score"
              value={call.q19_score}
              placeholder="سوال 19"
              {...register("q19_score")}
              error={!!errors.q19_score}
              // helperText={errors.q19_score ? errors.q19_score.message : ""}
              onChange={(e) => {
                setCall({ ...call, q19_score: e.target.value });
              }}
              fullWidth
            />
          </div>
          <div className="mb-6">
            <label htmlFor={"q1_score"} className="mb-2xs block text-sm text-ink-muted">
              سوال 20
            </label>
            <TextField
              name="q20_score"
              value={call.q20_score}
              placeholder="سوال 20"
              {...register("q20_score")}
              error={!!errors.q20_score}
              // helperText={errors.q20_score ? errors.q20_score.message : ""}
              onChange={(e) => {
                setCall({ ...call, q20_score: e.target.value });
              }}
              fullWidth
            />
          </div>
          <div className="mb-6 col-span-2">
            <label htmlFor={"extra_score"} className="mb-2xs block text-sm text-ink-muted">
              نمره اضافه
            </label>
            <TextField
              name="extra_score"
              value={call.extra_score}
              placeholder="نمره اضافه"
              {...register("extra_score", { required: "نمره را وارد کنید" })}
              error={!!errors.extra_score}
              // helperText={errors.extra_score ? errors.extra_score.message : ""}
              onChange={(e) => {
                setCall({ ...call, extra_score: e.target.value });
              }}
              fullWidth
            />
          </div>
          <div className="mb-6 col-span-3 flex items-end justify-center">
            <FileUploader
              value={call.assignment_teacher_file}
              onChange={(file) =>
                setCall((prev) => ({ ...prev, assignment_teacher_file: file }))
              }
              label="ارسال فایل"
            />
          </div>
        </div>
      </form>
    </ModalShell>
  );
});

export default AddAnswer;
